<script setup lang="ts">
import { useQuery } from '@tanstack/vue-query'
import { numKtoM } from '@/helpers/formating'
import { numFixed } from '@/helpers/helpers'
import { getUploadStats } from '@/store/api/gql/hands/queries'

const { data } = useQuery({
  queryKey: ['handsStatistics'],
  queryFn: getUploadStats,
})
</script>
<template>
  <div class="practice-stats-main-info statsmf">
    <div class="statsmf_box">
      <div class="statsmf_box_title">
        {{ $t('common.hands') }}
      </div>
      <div class="statsmf_box_value gw_loading_text">
        {{ numKtoM(data?.hand_statistics.count_hands || 0, 10000, 2) }}
      </div>
    </div>

    <div class="statsmf_box">
      <div class="statsmf_box_title">
        {{ $t('common.moves') }}
      </div>
      <div class="statsmf_box_value gw_loading_text">
        {{ numKtoM(data?.hand_statistics.total_moves || 0, 10000, 2) }}
      </div>
    </div>

    <div class="statsmf_box">
      <div class="statsmf_box_title">
        {{ $t('common.mistakes') }}
      </div>
      <div class="statsmf_box_value gw_loading_text">
        {{ numKtoM(data?.hand_statistics.total_mistake_moves || 0, 10000, 2) }}
      </div>
    </div>

    <div class="statsmf_box">
      <div class="statsmf_box_title">
        {{ $t('common.gto_score') }}
      </div>
      <div class="statsmf_box_value gw_loading_text">
        {{ numFixed((data?.hand_statistics.avg_gto_score || 0) * 100, 2) }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.statsmf {
  --flex-wrap: wrap;

  --display: grid;
  --gap: 2rem;
  --grid-template-columns: repeat(4, 1fr);
  --clr-title: var(--clr-grey-2);
  --clr-value: var(--clr-white-0);
  --size-title: 1rem;
  --size-value: 1.25rem;
  --weight-title: 500;
  --weight-value: 600;
  --transform-title: uppercase;
  --transform-value: uppercase;
  --item-margin: 0;

  display: var(--display);
  grid-template-columns: var(--grid-template-columns);
  grid-template-rows: var(--grid-template-rows);
  grid-auto-flow: var(--grid-auto-flow);
  gap: var(--gap);
  flex-wrap: var(--flex-wrap);

  &_box {
    display: flex;
    flex-direction: column;
    margin: var(--item-margin);
    &_title {
      font-size: var(--size-title);
      color: var(--clr-title);
      font-weight: var(--weight-title);
      text-transform: var(--transform-title);
    }
    &_value {
      color: var(--clr-value);
      font-size: var(--size-value);
      font-weight: var(--weight-value);
      text-transform: var(--transform-value);
    }
  }
}
</style>
